<template>
  <div class="datatime-w">
    <div class="time fz20 letter_spacing_1">{{ h }}:{{ m }}:{{ s }}</div>
    <div class="date fz14 letter_spacing_1">{{ y }}年{{ M }}月{{ d }}日</div>
    <div class="day fz14">星期{{ T[x] }}</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      s: '', // 秒
      m: '', // 分
      h: '', // 时
      y: '', // 年
      M: '', // 月
      d: '', // 日
      x: '', // 星期几
      T: ['日', '一', '二', '三', '四', '五', '六'],
      timer: null
    }
  },
  created() {
    this.timer = setInterval(() => {
      this.s = new Date().getSeconds().toString().padStart(2, 0)
      this.m = new Date().getMinutes().toString().padStart(2, 0)
      this.h = new Date().getHours().toString().padStart(2, 0)
      this.y = new Date().getFullYear()
      this.M = new Date().getMonth() + 1
      this.d = new Date().getDate()
      this.x = new Date().getDay()
    }, 1000)
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  }
}
</script>

<style lang="scss" scoped>
.datatime-w {
  display: flex;
  align-items: center;
  // width: 282px;
  color: #fff;

  .time {
  }
  .date {
    margin: 0 21px;
  }
  .date,
  .day {
  }
}
</style>
